import React from 'react'
import { FlexCell, FlexRow } from '@epam/loveship'

type SidebarPanelMainProps = {
  children: React.ReactNode
  withBorderBottom?: boolean
}

export const SidebarPanelMain = ({
  children,
  withBorderBottom,
}: SidebarPanelMainProps) => {
  return (
    <FlexRow padding="24" vPadding="24" borderBottom={withBorderBottom}>
      <FlexCell width="100%">{children}</FlexCell>
    </FlexRow>
  )
}
